let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d6wjH")).then(() => parcelRequire('h0YR4'));